import { Modal } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { Button } from "../../components";
import FileUploader from "../../components/FileUploader";
import { FormInput } from "../../components/forms";
import StandardParagraphTypeSelect from "../../components/forms/selects/StandardParagraphTypeSelect";
import ThemedModal from "../../components/utilities/ThemedModal";
import useCreateStandardParagraph from "./hooks/useCreateStandardParagraph";
import { useDropzone } from "react-dropzone";
import { ThemedIcon } from "../../components/utilities";
import { niceBytes } from "../../helpers/fileHelpers";

const uploadProps = {
    maxFiles: 1,
    accept: {
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": []
    }
}

const CreateStandardParagraphModal = ({ show, onHide }) => {
    const {
        onFileClear,
        onFileDrop,
        fileData,
        onClose,
        onSubmit,
        control,
        setValue,
        clearErrors,
        formState: { errors },
        isCreating
    } = useCreateStandardParagraph(onHide);

    const { getRootProps, getInputProps } = useDropzone({ ...uploadProps, onDrop: onFileDrop });
    const { name, size } = fileData || {};

    return <Modal show={show} backdrop="static" size="md" centered>
        <ThemedModal.Header>
            <Modal.Title>Create Standard Paragraph</Modal.Title>
        </ThemedModal.Header>
        <form onSubmit={onSubmit}>
            <Modal.Body className="d-flex row gy-2">
                <Controller
                    control={control}
                    name={'typeId'}
                    rules={{ required: "Please select a type of paragraph to create" }}
                    render={({ field: { ref, name, value, onChange, onBlur, ...rest } }) => (
                        <StandardParagraphTypeSelect
                            label="Select a Paragraph Type:"
                            value={value}
                            setValue={(newValue) => {
                                clearErrors(name);
                                setValue(name, newValue);
                            }}
                            disableAnimations
                            useOnChange
                            errorMessage={errors.typeId?.message}
                            errorAllowRetry={false}
                            {...rest}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={'name'}
                    rules={{ required: "Please enter a name for the new Standard Paragraph" }}
                    render={({ field: { ref, name, value, onChange, onBlur, ...rest } }) => (
                        <FormInput
                            label="Enter a Name for the new Paragraph:"
                            value={value}
                            onChange={(e) => {
                                clearErrors(name);
                                setValue(name, e.target.value);
                            }}
                            disableAnimations
                            errorMessage={errors.name?.message}
                            errorAllowRetry={false}
                            {...rest}
                        />
                    )}
                />
                <div className="mt-3">
                    {fileData == null
                        ? (
                            <div {...getRootProps({ className: 'dropzone d-flex px-3 py-2 border border-3 border-opacity-10' })}>
                                <input {...getInputProps()} />
                                <div className="d-flex flex-fill justify-content-center align-items-center py-4">
                                    <p className="m-0">Drag 'n' drop some files here, or click to select files</p>
                                </div>
                            </div>
                        )
                        : (
                            <div className="d-flex p-3 border border-3 border-opacity-10 mb-3">
                                <div className="d-flex justify-content-center align-items-center">
                                    <ThemedIcon icon={"fa-file-word"} size="2xl" variant="primary" />
                                </div>
                                <p className="flex-fill m-0 px-3 lh-1">
                                    <span>{name}</span>
                                    <br />
                                    <span className="text-muted fs-smallest">{niceBytes(size)}</span>
                                </p>
                                <div className="d-flex justify-content-center align-items-center">
                                    <ThemedIcon className="has-pointer" icon="fa-xmark" size="2xl" variant="danger" onClick={onFileClear} />
                                </div>
                            </div>
                        )
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type='submit'>Create</Button>
                <Button variant="light" onClick={onClose}>Cancel</Button>
            </Modal.Footer>
        </form>
    </Modal>
}

export default CreateStandardParagraphModal;